// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2ZOdy","imageWrapper":"fEruN","title":"IG_JX","description":"_2qbPR","smallDescr":"_35Mmi"};